import React, { useContext } from 'react'
import { NotificationManagerContext, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import CloseIcon from 'assets/icons/close'
import StatusSummaryBlock from 'src/components/Settings/StatusSummaryBlock'
import { useUpdatePage } from 'src/graphql/hooks'
import PageContext from '~/Page/libraries/context'
import GeneralSettings from '~/Page/pages/Settings/General'

const PageSettings = ({ returnUrl }) => {
   const page = useContext(PageContext)
   const { updatePage, mutating } = useUpdatePage()
   const { showNotification } = useContext(NotificationManagerContext)

   const handleUpdatePage = async (value) => {
      try {
         await updatePage({ id: page.id }, value)
         showNotification({
            message: 'Changes saved successfully',
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         showNotification({
            message: err.message || 'An error occurred while saving changes',
            title: 'Error',
            type: 'error'
         })
      }
   }

   return (
      <View
         position="absolute"
         top="0px"
         left="0px"
         right="0px"
         bottom="0px"
         borderRadius="6px[d-f]"
         backgroundColor="#0e171d"
         style={{ overflow: 'hidden' }}
         scroll="on[a-c]">
         <View
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            position="absolute"
            top="0px"
            right="0px"
            left="330px[d-f]"
            height="60px"
            backgroundColor="#f5f5f5[d-f]"
            borderBottom="1px solid rgba(0,0,0,0.1)[d-f]"
            padding="0px 18px"
            zIndex="2">
            <Link to={returnUrl} style={{ display: 'flex', alignItems: 'center' }}>
               <CloseIcon width="24px" height="24px" color="#888" />
            </Link>
         </View>
         <View
            position="absolute[d-f]"
            top="0px[d-f]"
            left="0px[d-f]"
            width="auto[a-c] 330px[d-f]"
            bottom="0px[d-f]"
            right="0px[a-c] auto[d-f]"
            backgroundColor="#0e171d"
            scroll="on[d-f]">
            <View
               width="100%"
               padding="30px">
               <Text size="5" weight="medium" color="#fff">
                  {page.title}
               </Text>
               <Text size="3" weight="medium" color="rgba(255,255,255,0.4)">
                  Page Settings
               </Text>
            </View>
            <StatusSummaryBlock
               archived={page.archived}
               dateLastUpdated={page.dateLastUpdated}
               entityName="Page"
               onPublishButtonClick={() => handleUpdatePage({ published: true })}
               onUnarchiveButtonClick={() => handleUpdatePage({ archived: false })}
               onUnpublishButtonClick={() => handleUpdatePage({ published: false })}
               published={page.published}
               textColor="rgba(255,255,255,0.8)"
               updating={mutating}
            />
         </View>
         <View
            position="absolute[d-f]"
            top="60px[d-f]"
            left="330px[d-f]"
            bottom="0px[d-f]"
            right="0px[d-f]"
            backgroundColor="#f5f5f5"
            scroll="on[d-f]">
            <GeneralSettings />
         </View>
      </View>
   )
}

PageSettings.propTypes = {
   returnUrl: PropTypes.string.isRequired
}

export default PageSettings
